import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminManualReferralsApi } from '../services/adminManualReferralsApi';

export type DeleteManualReferralInput = { id: string; reason?: string };

export const useDeleteManualReferral = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, DeleteManualReferralInput>({
    mutationFn: ({ id, reason }) => adminManualReferralsApi.deleteManualReferral(id, reason),
    onSuccess: () => {
      // Referrals tab + every metric that counted the voided fact.
      queryClient.invalidateQueries({ queryKey: ['analytics'] });
    },
  });
};
